import Modal from "@mui/material/Modal";
import EsfirusButtonNative from "@components/ui/Button/EsfirusButtonNative";
import EsfirusTextInput from "@components/ui/Text-input/EsfirusTextInput";
import { useMemo, useState } from "react";
import EsfirusSelect from "@components/ui/Select/EsfirusSelect";

const MAX_LONG_DESCRIPTION = 255
const entornoOptions = [
  { value: "master", label: "Producción (master)" },
  { value: "dev", label: "UAT (dev)" },
  { value: "other", label: "Otro" }
]

const SelectorEntorno = ({ options = [], value = "", setValue = () => { } }) => {
  const [entorno, setEntorno] = useState("")

  const onChangeEntorno = (e) => {
    setEntorno(e)

    if (e === "master") {
      setValue("master")
    } else if (e === "dev") {
      setValue("dev")
    } else {
      setValue("")
    }
  }

  const onChangeBranch = (e) => {
    setValue(e)
  }

  return (
    <>
      <div className="text-center mb-10">
        ¿Desde qué entorno quieres crear la compilación?
      </div>
      <EsfirusSelect
        options={entornoOptions}
        change={(e) => onChangeEntorno(e)}
        value={entorno}
        placeholder="Seleccionar el entorno"
      />

      {entorno === "other" && (
        <>
          <div className="text-center mb-10 mt-10">
            Escoge la rama frontend a compilar
          </div>
          <EsfirusSelect
            options={options.map(build => ({ value: build, label: build }))}
            change={(e) => onChangeBranch(e)}
            value={value}
            placeholder="Seleccionar la rama"
          />
        </>
      )}
    </>
  )
}

const ModalConfirmar = ({ title, open, onClose, initialText, loading, msgLoading, finished, msgFinished, failed, msgFailed, action, initialDescription = "", isCreateBuild = false, isEditBuild = false, frontBranches = [], setFrontBranchSelected = () => { }, frontBranchSelected = "" }) => {
  const [description, setDescription] = useState(initialDescription || "")
  const descriptionCharactersCounter = useMemo(() => description.length, [description])
  const buttonDisabled = useMemo(() => {
    if (!isCreateBuild && !isEditBuild) return false
    if (descriptionCharactersCounter > MAX_LONG_DESCRIPTION
      || !descriptionCharactersCounter
      || (isCreateBuild && !frontBranchSelected)) {
      return true
    }
  }

    , [descriptionCharactersCounter, frontBranchSelected, isCreateBuild]
  )

  const msg = useMemo(() => {
    if (failed) return msgFailed
    if (finished) return msgFinished
    if (loading) return msgLoading
    return initialText
  }, [initialText, loading, msgLoading, finished, msgFinished, failed, msgFailed])

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="new-confirm-modal-sign">
        <div className="header">
          <h5 className="text-center">
            {title}
          </h5>
        </div>
        <div className="body">
          {loading && <span className="loader" style={{ color: "#075577" }}></span>}
          {(isCreateBuild || isEditBuild) && !loading && !finished && !failed && (
            <>
              <div className="new-confirm-modal-desc-wrapper">
                <div className="text-center mb-10">
                  Escribe una pequeña descripción de la compilación
                </div>
                <EsfirusTextInput
                  fullWidth
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                <div className="new-confirm-modal-desc-note-character-left">
                  Carácteres restantes: {Math.max(MAX_LONG_DESCRIPTION - descriptionCharactersCounter, 0)}
                </div>
              </div>
              {isCreateBuild && (
                <div className="new-confirm-modal-desc-wrapper">
                  <SelectorEntorno
                    options={frontBranches}
                    value={frontBranchSelected}
                    setValue={setFrontBranchSelected}
                  />
                </div>
              )}
            </>
          )}
          <div className="text-center ph-30">
            {msg}
          </div>
          <div className="button-container">
            {!finished && (
              <EsfirusButtonNative
                click={async () => await action(description)}
                disabled={loading || buttonDisabled}
                label={isEditBuild ? "Editar" : isCreateBuild ? "Crear" : "Sí"}
              />
            )}
            <EsfirusButtonNative
              className={finished ? "" : "tertiary"}
              click={() => onClose()}
              disabled={loading}
              label={(isCreateBuild || isEditBuild) ? "Cancelar" : (finished ? "Cerrar" : "No")}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ModalConfirmar;
